var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoporte(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_74_1",
    "data-name": "Componente 74 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_272",
    "data-name": "Rect\\xE1ngulo 272",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "support_agent_FILL0_wght300_GRAD0_opsz40",
    d: "M109.012-803.9a.575.575,0,0,1-.424-.172.58.58,0,0,1-.171-.426.571.571,0,0,1,.171-.423.58.58,0,0,1,.424-.169h6.558a.308.308,0,0,0,.2-.073.238.238,0,0,0,.087-.191v-6.856a6.236,6.236,0,0,0-2.011-4.705,6.787,6.787,0,0,0-4.85-1.911,6.789,6.789,0,0,0-4.851,1.911,6.235,6.235,0,0,0-2.011,4.705v5.1a.467.467,0,0,1-.134.345.468.468,0,0,1-.345.134,1.619,1.619,0,0,1-1.17-.474,1.551,1.551,0,0,1-.488-1.156v-1.84a1.463,1.463,0,0,1,.262-.844,1.967,1.967,0,0,1,.685-.617l.044-1.21a7.329,7.329,0,0,1,.8-2.865,8.184,8.184,0,0,1,1.762-2.3,7.893,7.893,0,0,1,2.481-1.523A8.116,8.116,0,0,1,109-820a8.059,8.059,0,0,1,2.955.546,8.076,8.076,0,0,1,2.481,1.516,7.91,7.91,0,0,1,1.762,2.289,7.593,7.593,0,0,1,.811,2.866l.044,1.186a1.765,1.765,0,0,1,.68.557,1.332,1.332,0,0,1,.267.809v2.115a1.332,1.332,0,0,1-.267.809,1.767,1.767,0,0,1-.68.557v1.4a1.384,1.384,0,0,1-.436,1.029,1.446,1.446,0,0,1-1.045.425Z",
    transform: "translate(-95.999 825.104)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoporte);
export default __webpack_public_path__ + "static/media/soporte.ed86df4bb95c265f69efbc24a3999935.svg";
export { ForwardRef as ReactComponent };